import { BorderColor, VerticalAlignBottom } from "@mui/icons-material";
import { BsThreeDotsVertical } from "@/Components/Icons/Icons";
import { Divider } from "@mui/material";

export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "Air",
            actionText: "Air",
            component: "typographytext",
            // placeholder: "100.00%",
            width: "5%",
            sx: {
              alignItems: "center",
            },
          },
           {
            name: "airDropDown",
            component: "dropdown",
            width: "40%",
            gap: false,
            options: [
                {label : "%",value : "%"},
                {label : "-",value : "-"}
            ]
          },
          {
            name: "airTextField",
            component: "text-field",
            placeholder: "100.00%",
            width: "40%",
            gap: false,
            dataType: "int",
          },
        ],
        row3: [
          {
            name: "Sea",
            actionText: "Sea",
            component: "typographytext",
            // placeholder: "100.00%",
            width: "5%",
            sx: {
              alignItems: "center",
            },
          },
           {
            name: "seaDropDown",
            component: "dropdown",
            width: "40%",
            gap: false,
            options: [
                {label : "%",value : "%"},
                {label : "-",value : "-"}
            ]
          },
          {
            name: "seaTextField",
            component: "text-field",
            placeholder: "100.00%",
            width: "40%",
            gap: false,
            dataType: "int",
          },
        ],
      },
    },
  ],
};
